import FeedbackCollector from '@atlaskit/feedback-collector';
import React, { useRef } from 'react';
import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
const FEEDBACK_CONTEXT_ID = 'customfield_10047';
const DEFAULT_SUBMIT_BUTTON_LABEL = 'Give Feedback';
const DEFAULT_FEEDBACK_TITLE = 'Share your thoughts';
const DEFAULT_GROUP_LABELS = {
  bug: {
    selectOptionLabel: 'Report a bug',
    fieldLabel: 'Describe the issue'
  },
  comment: {
    selectOptionLabel: 'Leave a comment',
    fieldLabel: 'Describe your experience'
  },
  suggestion: {
    selectOptionLabel: 'Suggest an improvement',
    fieldLabel: 'What would you like to improve?'
  },
  question: {
    selectOptionLabel: 'Ask a question',
    fieldLabel: 'What would you like to know?'
  },
  empty: {
    selectOptionLabel: "I'd like to...",
    fieldLabel: ''
  }
};
export const FeedbackCollectorDialog = _ref => {
  let {
    userId,
    name,
    feedbackGatewayBaseUrl,
    entrypointId,
    feedbackDialogVisible,
    onSubmit,
    onClose,
    feedbackGroupLabels = DEFAULT_GROUP_LABELS,
    submitButtonLabel = DEFAULT_SUBMIT_BUTTON_LABEL,
    feedbackTitle = DEFAULT_FEEDBACK_TITLE,
    feedbackTitleDetails,
    anonymousFeedback = false,
    showTypeField = true,
    customTextAreaLabel
  } = _ref;
  const ref = useRef(null);

  // info for feedback context
  const location = window.location.href;
  const userAgent = navigator.userAgent;
  const screenResolution = "".concat(window.screen.width, " x ").concat(window.screen.height);
  const feedbackContext = ["Location: ".concat(location), "User-Agent: ".concat(userAgent), "Screen Resolution: ".concat(screenResolution)].join('\n');
  return /*#__PURE__*/_jsx(_Fragment, {
    children: feedbackDialogVisible && /*#__PURE__*/_jsx(FeedbackCollector, {
      locale: "en",
      customGatewayUrl: "".concat(feedbackGatewayBaseUrl),
      onClose: onClose,
      onSubmit: onSubmit,
      atlassianAccountId: userId,
      name: name,
      additionalFields: [{
        id: FEEDBACK_CONTEXT_ID,
        value: feedbackContext
      }],
      entrypointId: entrypointId,
      submitButtonLabel: submitButtonLabel,
      feedbackTitle: feedbackTitle,
      feedbackGroupLabels: feedbackGroupLabels,
      showTypeField: showTypeField,
      customTextAreaLabel: customTextAreaLabel,
      anonymousFeedback: anonymousFeedback,
      feedbackTitleDetails: feedbackTitleDetails,
      shouldReturnFocusRef: ref
    })
  });
};